document.addEventListener('DOMContentLoaded', () => {
  const modal_trigger = 'modal-order';

  const modal = document.querySelector('[data-' + modal_trigger + ']');
  if (!modal) return;

  let previouslyFocused = null;

  function openModal() {
    previouslyFocused = document.activeElement;
    modal.classList.remove('hidden');
    modal.removeAttribute('inert');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('role', 'dialog');
    document.body.style.overflow = 'hidden';
    modal.setAttribute('tabindex', '-1');
    modal.focus();
  }

  function closeModal() {
    modal.classList.add('hidden');
    modal.setAttribute('inert', '');
    modal.removeAttribute('aria-modal');
    modal.removeAttribute('role');
    modal.removeAttribute('tabindex');
    document.body.style.overflow = '';
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
  }

  function removeModalHash(){
    if (window.location.hash === '#' + modal_trigger) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    }
  }

  modal.addEventListener('keydown', (e) => {
    switch (e.key) {
      case 'Escape':
        removeModalHash();
        break;
      case 'Tab': 
        const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
        break;
    }
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      removeModalHash();
    }
  });

  modal.querySelector('.close-modal').addEventListener('click', (e) => {
    e.preventDefault();
    removeModalHash();
  });

  if (window.location.hash === '#' + modal_trigger) {
    openModal();
  }

  window.addEventListener('hashchange', () => {
    if (window.location.hash === '#' + modal_trigger) {
      openModal();
    } else {
      closeModal();
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  function renderUrlButtons(container, urls, fallbackLabel) {
    container.innerHTML = '';
    urls.forEach((item) => {
      if (!item.url) return;
      const link = document.createElement('a');
      link.href = item.url;
      link.target = '_blank';
      link.rel = 'noopener';
      link.className = 'btn-primary';
      link.textContent = item.title || fallbackLabel;
      container.appendChild(link);
    });
  }

  const updateOrderPopupVenue = () => {
    const venue = get_current_venue_info();
    const modal = document.querySelector('[data-modal-order]');

    if(!venue || !modal) return;

    const venueName = modal.querySelector('.venue-name');
    const venueAddress = modal.querySelector('.venue-address');
    const venuePhone = modal.querySelector('.venue-phone');
    const takeoutContainer = modal.querySelector('.takeout-buttons');
    const deliveryContainer = modal.querySelector('.delivery-buttons');

    if(!takeoutContainer || !deliveryContainer) return;

    if(venue.name){
      venueName.innerText = venue.name;
      venueName.classList.remove('hidden');
    }else{
      venueName.classList.add('hidden');
    }

    if(venue.address){
      venueAddress.innerText = venue.address;
      venueAddress.classList.remove('hidden');
    }else{
      venueAddress.classList.add('hidden');
    }

    if(venue.telephone){
      venuePhone.innerText = venue.telephone;
      venuePhone.classList.remove('hidden');
    }else{
      venuePhone.classList.add('hidden');
    }

    const takeoutUrls = Array.isArray(venue.takeout_urls) ? venue.takeout_urls.filter((i) => i.url) : [];
    const deliveryUrls = Array.isArray(venue.delivery_urls) ? venue.delivery_urls.filter((i) => i.url) : [];

    if(takeoutUrls.length > 0){
      renderUrlButtons(takeoutContainer, takeoutUrls, 'Order Takeout');
      takeoutContainer.closest('.order-option').classList.remove('hidden');
    }else{
      takeoutContainer.innerHTML = '';
      takeoutContainer.closest('.order-option').classList.add('hidden');
    }

    if(deliveryUrls.length > 0){
      renderUrlButtons(deliveryContainer, deliveryUrls, 'Order Delivery');
      deliveryContainer.closest('.order-option').classList.remove('hidden');
    }else{
      deliveryContainer.innerHTML = '';
      deliveryContainer.closest('.order-option').classList.add('hidden');
    }

    const orderOptions = modal.querySelector('.order-options');
    if(takeoutUrls.length === 0 && deliveryUrls.length === 0){
      orderOptions.classList.add('hidden');
    }else{
      orderOptions.classList.remove('hidden');
    }
  }

  updateOrderPopupVenue();
  document.body.addEventListener('venueChanged', updateOrderPopupVenue);
});